import React from 'react';
import './ELogo.css';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/ELOGO.png?v=2`;

/**
 * Ehgezly brand mark — uses the official ELOGO.png (green squircle + folded E).
 *
 * @param {'small' | 'medium' | 'large' | 'xlarge'} [size='large']
 * @param {string} [className='']
 */
const ELogo = ({ size = 'large', className = '' }) => (
  <div
    className={`e-logo e-logo-${size} ${className}`.trim()}
    aria-label="Ehgezly logo"
    role="img"
  >
    <div className="e-logo-mark">
      <img src={LOGO_SRC} alt="" className="e-logo-image" draggable="false" />
    </div>
  </div>
);

export default ELogo;
